import { Container, Image } from "react-bootstrap";
import { NavBar } from "./components/NavBar";
import { Footer } from "./components/Footer";
import React, { useEffect, useState } from "react";
import TravelerProfileIssuer from "./components/multistep/TravelerProfileIssuer";
import { AuthorizationResponsePayload } from "@sphereon/ssi-sdk.siopv2-oid4vp-common";
import { CredentialMapper } from "@sphereon/ssi-types";
import VoiceChat from "src/components/VoiceChat/VoiceChat";

export type TravelerProfilePageProps = {
  payload: AuthorizationResponsePayload;
  onApply?: () => void;
};

export const TravelerProfilePage = (props:TravelerProfilePageProps) => {
    let fullName = "";

    const [showTravelProfileIssuer, setShowTravelProfileIssuer] = useState(false); 
    const [showVoiceChat, setShowVoiceChat] = useState(false); 

    const voiceFinished = () => {

    }

    // Function to extract subjects from the payload

  const getSubjects = (payload: AuthorizationResponsePayload, index: number = 0) => {
      if (payload) {
        const presentation = CredentialMapper.toWrappedVerifiablePresentation(
          Array.isArray(payload.vp_token)
            ? payload.vp_token[0]
            : payload.vp_token!,
        );
        const subjects =
          presentation?.presentation?.verifiableCredential[index].credential
            .credentialSubject!; // Although rare, a VC can have more than one subject
        return subjects;
      }
      return null;
    }

    useEffect(() => {
      if (props.payload)
        fullName = (getSubjects(props.payload) as any)?.firstName + " " + (getSubjects(props.payload) as any)?.lastName;  
      else
        fullName= "Bogdan Mocanu";
      }
    , [props.payload]);

    

  return (
    <Container style={{ maxWidth: "100%", padding: "0px" }}>
      <NavBar />
      <div className="banner-section">
        <div>
          <Image
            style={{
              width: "100%",
            }}
            src={require("./reception.jpg")}
          ></Image>
          <div
            style={{
              position: "absolute",
              top: 0,
              left: 0,
              width: "100%",
              backgroundColor: "rgba(0, 0, 0, 0.6)",
            }}
          ></div>
        </div>
        <div className="content-box" style={{ color: "black !important" }}>
          <h1 data-animation-in="fadeInUp" data-delay-in="0.3">
            Talk to the AI agent to build your traveler profile
          </h1>
          <span
            className="sub-title"
            data-animation-in="fadeInUp"
            data-delay-in="0.1"
          >
            This profile you can take it with you and use it anywhere to personilize quickly your travel experience. You can also very easily and conviniently share it with hotels, airlines, and other travel service providers, to easily and securely get the service you need.
          </span>
          <a
            href="#checkin-wizard"
            onClick={() => {
              setShowVoiceChat(true);
            }}
            className="btn"
            data-animation-in="fadeInUp"
            data-delay-in="0.5"
            style={{ width: "250px" }}
          >
            Get my Traveler Profile
          </a>
        </div>
      </div>

      <div
        id="checkin-wizard"
        className="pre-check-in-box"
        style={{ margin: "200px 100px 0px 100px" }}
      >
        {showTravelProfileIssuer ? (
            <TravelerProfileIssuer fullName={fullName} /> 
        ) : (
        (showVoiceChat ? <VoiceChat onFinish={() => setShowTravelProfileIssuer(true)} systemMessage="You are a helpful traveling AI assistant. You would like to gather information from the user in a very friendly way, by helping her to discover what she likes to do when traveling. You need to fill out the HATPro schema definition to fill out a traveler profile. You are helping the user search for traveling options and gather information in the same time. Ask also specific questions to fill out the data from the HATPro document: https://github.com/decentralized-identity/hatpro-schema/blob/main/supportingDocuments/HATPro%20Implementation%20Guide.docx . Keep the communication under 15 seconds and never close the conversation from you. You should keep asking questions to complete the traveler profile of the user. When the user says thank you, you will say that you compleated users traveling profile and she can follow the next steps to download it."/> : <></>)
        )}
      </div>
      <Footer />
    </Container>
  );
};
